

// const ADD_URL = URL_APP + "api/v1/rincian_obyek/";

  import Joi from "joi";

  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(16).max(20).required(),
    password: Joi.string().min(6).required(),
  });

// import { Notify  } from 'quasar'
// import Registrasi from "../dataMaster/registrasi.vue";

  export default {
    data : function(){
      return {

          errorMessage: '',
          user : {
            username : "",
            NIK : "",
            password : ""
          },

          dataku: {
          id : '',
          nama:"",
          nik : '',
          hp: "",
          email: "",
          jk : '',
          pekerjaan:"",
          alamat:"",
          password : "",
          confirmPassword: "",
          menu_klp : 3,
      },

      signingUp : false,
      errorMessage: '',

          jk: [
                  { uraian: 'Laki-Laki', id: 1 },
                  { uraian: 'Perempuan', id: 2 }
          ],

          url : {
            LOGIN_URL : this.$store.state.url.URL_APP + "auth/login",
          }
      }
    },
    watch: {
      user: {
          handler() {
              this.errorMessage = "";
          },
          deep: true
      }
    },
    methods: {
      // go_register : function(){
      //   alert(App.data().sesseee);
      //   this.displayed = 'block';
      // },
      
      login : function(){
        this.$router.push('/login');
      },


      regis : function(){
      
        this.errorMessage = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            const body = {
              username: this.dataku.nik,
              password: this.dataku.password
            };
            this.signingUp = true;

            fetch(this.$store.state.url.URL_REGISTRASI+'daftar', {
                method: "POST",
                body: JSON.stringify(this.dataku),
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            }).then((response) => {
                this.signingUp = false;
                console.log(response)
                if (response.ok) {
                    //  this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                    this.errorMessage = "Sukses Menambah Data";
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                this.signingUp = false;
                this.errorMessage = error.message;
              }, 1000);
            });
            

        }else{
          console.log("tidak valid");

        }


      },

      validUser : function(){

        if (this.dataku.password !== this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password harus sama. !";
            return false;
        }
        // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
        // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
        const body = {
                username: this.dataku.nik,
                password: this.dataku.password
        };


        const result = schema.validate(body);
        // console.log(result)

        if (result.error === null || result.error === undefined) {
            console.log("SDH BENAR")
            return true;
        }
        if (result.error.message.includes("username")) {
    // jika pesan error yang dihasilkan mengandung char "username" maka
            this.errorMessage = "NIK tidak valid (Harap Inputkan NIK yang Benar)";
        } else {
            this.errorMessage = "Password tidak valid (Min : 6 Karakter)";

        }
        // console.log(this.errorMessage);
        return false;
        },


      
    },
    mounted : function(){

      
      

    },
  };
